<template>
  <div>
    <slot name="clickArea"></slot>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="showAttachmentModal"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <b-row>
        <b-col cols="12">
          <uploadFile
            v-if="code"
            :title="title"
            :allowCollapse="false"
            :isCollapseFiles="true"
            keyServies="person"
            size="xl"
            :keyValue="code"
            :outParams="{ attachment_type_id: [21] }"
            :parentPermissions="['view']"
            :propAttachmentType="false"
            :file_types="['image', 'office', 'media', 'other']"
          />
        </b-col>
        <b-col cols="12" class="text-right">
          <b-button
            class="mt-3"
            size="md"
            variant="danger"
            @click="$emit('updateModal', false)"
          >
            {{ $lang.cancelButton }}
            <i class="fa fa-ban"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import uploadFile from "@/components/base/uploadFile";
export default {
  components: {
    uploadFile,
  },
  props: {
    attachmentModel: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String | Number,
      default: "",
    },
    title: {
      type: String | Number,
      default: "",
    },
  },
  data() {
    return {
      showAttachmentModal: false,
    };
  },
  watch: {
    attachmentModel(value) {
      this.showAttachmentModal = value;
    },
  }
};
</script>